import { render, staticRenderFns } from "./SavedSearchesMenu.vue?vue&type=template&id=27eecfce&scoped=true&"
import script from "./SavedSearchesMenu.vue?vue&type=script&lang=js&"
export * from "./SavedSearchesMenu.vue?vue&type=script&lang=js&"
import style0 from "./SavedSearchesMenu.vue?vue&type=style&index=0&id=27eecfce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27eecfce",
  null
  
)

export default component.exports